let tokenId = null;
let ipAddress = null;
let headers = null;
let txToken = null;

function setToken(token) {
  tokenId = token;
}

function getToken() {
	return tokenId;
}

function setIPaddress(ipValue) {
  ipAddress = ipValue;
}

function getIPaddress() {
	return ipAddress;
}

function setHeaders(headersValue){
  headers = headersValue;
}

function getHeaders() {
	return headers;
}

function setTxToken(tokenValue){
  txToken = tokenValue;
}

function getTxToken() {
	return txToken;
}

module.exports = {
  setToken : setToken,
  getToken: getToken,
  setIPaddress: setIPaddress,
  getIPaddress: getIPaddress,
  
  setHeaders: setHeaders,
  getHeaders: getHeaders,

  setTxToken: setTxToken,
  getTxToken: getTxToken
};
